module.exports = __webpack_public_path__ + "img/arrow_forward.ae583dfa.svg";